export default "__VITE_PUBLIC_ASSET__471eced9__"